export enum UserRoles {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  ACCOUNT_OWNER = 'account_owner',
  ACCOUNT_ADMIN = 'account_admin',
  TEAM_MEMBER = 'team_member'
}
